// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import Slider from "./views/Slider"
import ServiceType from './views/Service/serviceType.jsx'
import Services from './views/Service/services.jsx';
import Category from './views/Category/category.jsx';
import SubCategory from './views/Category/subCategory';
import OrderStatus from './views/Order/orderStatuses';
import Order from './views/Order/order';
import FormListing from './views/Settings/Forms/formListing';
import CreateForm from './views/Settings/Forms/createForm';
import DriverManagement from './views/Drivers/driver';
import Payout from "views/Payout/payout";
import DriverSettlement from "views/DriverSettlement/DriverSettlement";
import DriverDetail from './views/Drivers/driverDetail';
import VehicleManagement from './views/Drivers/vehicles';
import PrivacyPolicy from './views/Pages/PrivacyPolicy';
import Tutorial from './views/Settings/tutorial';
import News from './views/Pages/news';
import TermCondition from './views/Pages/TermCondition';
import AboutUs from './views/Pages/AboutUs';
import Faqs from './views/Pages/Faqs';
import BoardingScreen from './views/Settings/boardingScreen';
import NotificationManagement from './views/Settings/notification';
import Admin from './views/Admin/Admin';
import Bullet from './views/Bullet/Bullet.jsx';
import Customers from './views/Customers/customers.jsx';
import CustomerDetail from './views/Customers/customerDetail.jsx';

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    // icon: <Icon fontSize="small">group</Icon>,
    route: "/dashboard/customers/list",
    component: <Customers />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Customer Detail",
    key: "customer-detail",
    route: "/dashboard/customers/details/:id?",
    component: <CustomerDetail />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Slider",
    key: "slider",
    icon: <Icon fontSize="small">Slider</Icon>,
    route: "/dashboard/slider",
    component: <Slider />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Service Type",
    key: "service-type",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/services/service-type",
    component: <ServiceType />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Services",
    key: "services",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/services/list",
    component: <Services />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/categories/list",
    component: <Category />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Sub Categories",
    key: "sub-categories",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/categories/sub-categories",
    component: <SubCategory />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Order Statuses",
    key: "order-statuses",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/orders/order-statuses",
    component: <OrderStatus />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/orders/list",
    component: <Order />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Drivers",
    key: "drivers",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/drivers/list",
    component: <DriverManagement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Payout",
    key: "Payout",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/payout/list",
    component: <Payout />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Driver Settlement",
    key: "Driver-Settlement",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/driverSettlement/list",
    component: <DriverSettlement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Vehicles",
    key: "vehicles",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/drivers/vehicles",
    component: <VehicleManagement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Drivers",
    key: "drivers",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/drivers/details/:id?",
    component: <DriverDetail />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Custom Form",
    key: "custom-form",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/custom-form",
    component: <FormListing />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Create Form",
    key: "create-form",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/create-form",
    component: <CreateForm />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Create Form",
    key: "create-form",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/update-form/:id?",
    component: <CreateForm />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Boarding Screen",
    key: "boarding-screen",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/boarding-screen",
    component: <BoardingScreen />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Tutorials",
    key: "tutorial",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/tutorial",
    component: <Tutorial />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Notification",
    key: "notification",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/notification",
    component: <NotificationManagement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Admin",
    key: "Admin",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/Admin/list",
    component: <Admin />,
    isPrivate: true,
  },
  {
    name: "Bullet",
    key: "Bullet",
    route: "/dashboard/Bullet/list",
    component: <Bullet />,
    isPrivate: true,

  },
  {
    type: "collapse",
    name: "Privacy Policy",
    key: "privacy-policy",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/privacy-policy",
    component: <PrivacyPolicy />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Terms & Conditions",
    key: "terms-conditions",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/terms-conditions",
    component: <TermCondition />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "About Us",
    key: "about-us",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/about-us",
    component: <AboutUs />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "News",
    key: "news",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/news",
    component: <News />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Faqs",
    key: "faqs",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/faqs",
    component: <Faqs />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
  },

];

export default routes;
